import { IRutinInfo } from '../../../../../Types/RutinInfoType';
import { rutinInfos } from '../RutinInfo';

const LRRutinMeny: IRutinInfo[] = [
  rutinInfos.rtnLeverantorer,
  rutinInfos.rtnWebFakturaAttest,
  rutinInfos.rtnFakturabunt,
  rutinInfos.rtnFakturabevakning,
  rutinInfos.rtnBetalRedov,
  rutinInfos.rtnAttestanter,
  rutinInfos.rtnWebLeverantorsfakturor,
  rutinInfos.rtnPostnr,
  rutinInfos.rtnOrgPersLok,
  rutinInfos.rtnVisaLeverantorsAttester,
];

export default LRRutinMeny;
